import { OrgSubscriptions } from "../entities/OrgSubscriptions";
import { ApiService } from "./ApiService";

export class UnsubscribeService {
    private readonly apiService: ApiService;

    constructor(apiService: ApiService) {
        this.apiService = apiService;
    }

    public async getSubscriptions(hash: string, orgId: string): Promise<OrgSubscriptions> {
        return (await this.apiService.getNoOrg(`unsubscribe/subscriptions/${hash}?organizationId=${orgId}`)) as OrgSubscriptions;
    }

    public async unsubscribeFromLists(hash: string, orgId: string): Promise<unknown[]> {
        return (await this.apiService.postNoOrg(`unsubscribe/lists/${hash}?organizationId=${orgId}`, {})) as unknown[];
    }

    public async unsubscribeFromAll(hash: string, orgId: string): Promise<unknown[]> {
        return (await this.apiService.postNoOrg(`unsubscribe/all/${hash}?organizationId=${orgId}`, {})) as unknown[];
    }
}
